import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import { ROLE_FINSIGHT_ID, ROLE_INVESTOR_ID } from '@/creditflowresearch/domain/Role';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import RoadshowsTile from './RoadshowsTile';
import { useSessionContext } from '@users/session/SessionContext';

interface IRoadshowsTileWithFallbackProps {
  userAccessChecks: boolean[],
}

const RoadshowsTileWithFallback = ({ userAccessChecks }: IRoadshowsTileWithFallbackProps) => {
  const { checkAccessByUserPlan, role } = useUserPlanContext();
  const { currentUser } = useSessionContext();
  const roleId = role ? role.id : null;

  const checks = [
    ...userAccessChecks,
    checkAccessByUserPlan(UserPlanType.PREMIUM),
    [ROLE_FINSIGHT_ID, ROLE_INVESTOR_ID].includes(roleId),
    !!currentUser,
  ];

  return (
    <CheckUserAccess conditions={ [{ checks }] }>
      <RoadshowsTile />
    </CheckUserAccess>
  );
};

export default RoadshowsTileWithFallback;
